import { t } from "i18next";

export const blockTitle = (title: string | undefined): string =>
  title || t("General information");
